import { CustomerDataStoreImpl, CustomerDataStore } from "./CustomerDataStore";
import { Store } from "../utils/Store";
import { OrderEntryActions } from "../actions/OrderEntryActions";
import { SessionStore } from "../uidispatcherapi/SessionStore";
import { CartContextActions } from "../actions/CartContextActions";
import type { Dictionary } from "./BaseTypes";
import type { CardholderData, CheckoutCustomer } from "../model/CheckoutData";
export type CardholderSelectState = {
	cardholders: Dictionary<CardholderData>;
	selectedCardholder?: string | null;
};
export class CardholderSelectStoreImpl extends Store {
	_customerId: string | null | undefined;
	_selectedCardholder: string | null | undefined;
	_customerDataStore: CustomerDataStoreImpl;

	constructor(customerDataStore: CustomerDataStoreImpl) {
		super();
		this._customerId = null;
		this._selectedCardholder = null;
		this._customerDataStore = customerDataStore;
		this.listenTo(this._customerDataStore, this.handleCustomerChanged);
		this.listenTo(OrderEntryActions.onSelectCardholder, this.handleSelectCardholder);
	}

	storageKey(customer: CheckoutCustomer) {
		return "selectedCardholderFor-" + customer.customerId;
	}

	handleCustomerChanged() {
		CartContextActions.onSelectCardholder(this.getSelectedCardholder() || "");
		this.trigger();
	}

	handleSelectCardholder(id: string) {
		const customer = this._customerDataStore.getCustomer();

		if (customer) {
			this._selectedCardholder = id;
			this._customerId = customer.customerId;

			if (window.localStorage) {
				window.localStorage.setItem(this.storageKey(customer), id);
			}

			CartContextActions.onSelectCardholder(id);
			this.trigger();
		}
	}

	getSelectedCardholder(): string | null | undefined {
		if (!SessionStore.isEmployee()) {
			return SessionStore.getCardholderNumber();
		}

		const customer = this._customerDataStore.getCustomer();

		if (!customer) {
			return null;
		}

		if (this._selectedCardholder) {
			if (this._customerId === customer.customerId) {
				return this._selectedCardholder;
			} else {
				this._customerId = customer.customerId;
				this._selectedCardholder = null;
			}
		}

		if (window.localStorage) {
			const selected = window.localStorage.getItem(this.storageKey(customer));

			if (selected && customer.cardholderById[selected]) {
				return selected;
			}
		}

		return customer.primaryCardholderNumber;
	}

	getState(): CardholderSelectState {
		const customer = this._customerDataStore.getCustomer();

		const cardholders = (customer && customer.cardholderById) || {};
		const selectedCardholder = this.getSelectedCardholder();
		return {
			cardholders,
			selectedCardholder,
		};
	}
}
export const CardholderSelectStore = new CardholderSelectStoreImpl(CustomerDataStore);
